import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
export const fetchUpgradeConfig = (upgradeKey, providedIndustry, retry = true) => {
  const queryParams = providedIndustry ? `?providedIndustry=${providedIndustry}` : '';
  return http.get(`${getFullUrl('app-api')}/upgrade-management-service/v1/upgrade-configs/${upgradeKey}${queryParams}`).then(response => response).catch(error => {
    if (retry) {
      return fetchUpgradeConfig(upgradeKey, providedIndustry, false);
    }
    if (error && error.status !== 0) {
      Raven.captureException(error);
    }
    throw error;
  });
};